import React, { useCallback, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { removeSavedMessage } from "../../store/slices/chatSlice";

import Drawer from "../Drawer/Drawer";
import "./SavedMessages.css";
import SavedMessageItem from "../SavedMessageItem/SavedMessageItem";

interface SavedMessagesProps {
  isOpen: boolean;
  onClose: () => void;
}

const truncateText = (text: string, maxLength: number = 200): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + "...";
};

const SavedMessages: React.FC<SavedMessagesProps> = ({ isOpen, onClose }) => {
  const { savedMessages } = useAppSelector((state) => state.chat);
  const dispatch = useAppDispatch();
  const [expandedMessageId, setExpandedMessageId] = useState<string | null>(
    null
  );

  const sortedMessages = useMemo(() =>
    [...savedMessages].sort(
      (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
    ), [savedMessages]);

  const handleDelete = useCallback((messageId: string) => {
    dispatch(removeSavedMessage(messageId));
  }, [dispatch]);

  const toggleExpanded = useCallback((messageId: string) => {
    setExpandedMessageId(prev => prev === messageId ? null : messageId);
  }, []);

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      position="right"
      width="400px"
      title="Gespeicherte Nachrichten"
      showCloseButton={true}
    >
      <div className="saved-messages-content">
        {savedMessages.length === 0 ? (
          <div className="empty-state">
            <p>Noch keine gespeicherten Nachrichten</p>
          </div>
        ) : (
          <div className="saved-messages-list">
            {sortedMessages.map((message) => (
              <SavedMessageItem
                key={message.id}
                message={message}
                isExpanded={expandedMessageId === message.id}
                onToggleExpanded={() => toggleExpanded(message.id)}
                onDelete={() => handleDelete(message.id)}
                truncateText={truncateText}
              />
            ))}
          </div>
        )}
      </div>
    </Drawer>
  );
};

export default SavedMessages;
